import { RefreshCw } from "lucide-react";
import { Tooltip } from "@/components/ui";
import { AssetFilters, type AssetFilterType } from "./asset-filters";
import { cn } from "@/lib/utils";

interface AssetsHeaderProps {
  filter: AssetFilterType;
  isFetching: boolean;
  isExiting: boolean;
  onRefresh: () => void;
  onFilterChange: (filter: AssetFilterType) => void;
}

export function AssetsHeader({
  filter,
  isFetching,
  isExiting,
  onRefresh,
  onFilterChange,
}: AssetsHeaderProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
      <div className="flex items-center gap-3">
        <h1 className="text-xl sm:text-2xl font-bold text-white">Your Assets</h1>
        <Tooltip title="Refresh" position="bottom" align="center">
          <button
            onClick={onRefresh}
            disabled={isFetching}
            className="p-2 rounded-lg text-[#666] hover:text-white hover:bg-white/[0.05] transition-colors disabled:opacity-50"
          >
            <RefreshCw className={cn("size-5", isFetching && "animate-spin")} />
          </button>
        </Tooltip>
      </div>
      <AssetFilters
        value={filter}
        onChange={onFilterChange}
        isLoading={isFetching || isExiting}
      />
    </div>
  );
}
